import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapFieldsComponent } from './map-fields.component';
import {MapSidebarTabsModule} from '../map-sidebar-tabs/map-sidebar-tabs.module';
import {
  DxButtonModule, DxContextMenuModule,
  DxDataGridModule,
  DxDeferRenderingModule,
  DxDropDownButtonModule,
  DxListModule,
  DxTextBoxModule, DxToolbarModule
} from 'devextreme-angular';
import {FieldSvgModule} from 'shared';
import {TabModule} from '../tab/tab.module';
import { MapFieldPopupComponent } from './map-field-popup/map-field-popup.component';
import {FieldCropsPopupModule} from '../field-crops/field-crops-popup/field-crops-popup.module';
import {MapSidebarGroupHeaderModule} from '../map/map-sidebar-group-header/map-sidebar-group-header.module';



@NgModule({
  declarations: [MapFieldsComponent, MapFieldPopupComponent],
  imports: [
    CommonModule,
    MapSidebarTabsModule,
    DxListModule,
    DxButtonModule,
    FieldSvgModule,
    TabModule,
    DxDataGridModule,
    DxDropDownButtonModule,
    DxDeferRenderingModule,
    FieldCropsPopupModule,
    DxTextBoxModule,
    DxToolbarModule,
    MapSidebarGroupHeaderModule,
    DxContextMenuModule,
  ],
  exports: [MapFieldsComponent, MapFieldPopupComponent]
})
export class MapFieldsModule { }
